export function formatBytes(value, signed = false) {
  if (value == null || Number.isNaN(Number(value))) return '—'
  const amount = Number(value)
  const prefix = signed && amount > 0 ? '+' : ''
  const absolute = Math.abs(amount)
  const units = ['B', 'KB', 'MB', 'GB']
  let index = 0
  let normalized = absolute
  while (normalized >= 1024 && index < units.length - 1) {
    normalized /= 1024
    index += 1
  }
  const precision = normalized >= 100 || index === 0 ? 0 : 1
  return `${prefix}${amount < 0 ? '-' : ''}${normalized.toFixed(precision)} ${units[index]}`
}

export function formatPercent(value) {
  return value == null || Number.isNaN(Number(value)) ? '—' : `${Number(value).toFixed(1)}%`
}

export function formatDuration(value) {
  if (value == null) return '—'
  const milliseconds = Math.max(0, Number(value))
  if (milliseconds < 1000) return `${milliseconds} ms`
  const seconds = milliseconds / 1000
  if (seconds < 60) return `${seconds.toFixed(seconds < 10 ? 1 : 0)} s`
  const minutes = Math.floor(seconds / 60)
  return `${minutes} min ${Math.floor(seconds % 60)} s`
}

export function formatDate(locale, value) {
  if (!value) return '—'
  const localeName = locale === 'uk' ? 'uk-UA' : locale === 'ru' ? 'ru-RU' : 'en-GB'
  return new Date(value).toLocaleString(localeName, { dateStyle: 'short', timeStyle: 'medium' })
}

export function runKind(t, kind) {
  return t({ report_pdf: 'reportPdf', chart_jpeg: 'chartJpeg', chart_pdf: 'chartPdf' }[kind] ?? 'report')
}

export function runOutcome(t, run) {
  return run.status === 'succeeded' ? t('completed') : t('failed')
}

export function auditEventLabel(t, eventType) {
  return t(`auditEvent_${eventType}`) === `auditEvent_${eventType}`
    ? eventType.replace(/_/g, ' ')
    : t(`auditEvent_${eventType}`)
}
